import { useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import copy from '../../demo/fixtures/w5/copy.json'
import { Badge, Card, CardHead, Icon, Input, Table, TableBody, TableCell, TableHead, TableHeader, TableRow, Term } from '../../ui'
import { useW5Live } from './live'
import styles from './AnalysisPage.module.css'

export function TaskMonitorCard() {
  const navigate = useNavigate()
  const { taskRows } = useW5Live()
  const [query, setQuery] = useState('')
  const visibleRows = useMemo(() => {
    const normalized = query.trim().toLocaleLowerCase('zh-Hans')
    return normalized ? taskRows.filter((task) => `${task.product}\n${task.adName}`.toLocaleLowerCase('zh-Hans').includes(normalized)) : taskRows
  }, [query, taskRows])
  return (
    <Card className={styles.section} data-scope="task-monitor">
      <CardHead
        title={copy.sections.taskMonitor}
        subtitle={`${taskRows.length} 个广告任务`}
        action={<Input className={styles.search} icon={<Icon name="search" size={17} />} value={query} placeholder={copy.sections.searchPlaceholder} onChange={(event) => setQuery(event.target.value)} />}
      />
      <div className={styles.tableWrap}>
        <Table className={styles.taskTable}>
          <TableHead>
            <TableRow>
              <TableHeader>广告任务</TableHeader>
              <TableHeader>状态</TableHeader>
              <TableHeader>花费（7 天）</TableHeader>
              <TableHeader><Term k="ctr" /></TableHeader>
              <TableHeader><Term k="cpa" /> / <Term k="cpm" /></TableHeader>
              <TableHeader><Term k="roas" /></TableHeader>
              <TableHeader>触达人数</TableHeader>
              <TableHeader>监控</TableHeader>
            </TableRow>
          </TableHead>
          <TableBody>
            {visibleRows.map((task) => (
              <TableRow clickable key={task.campaignId} tabIndex={0} onClick={() => void navigate(`/monitor/${task.campaignId}`)} onKeyDown={(event) => { if (event.key === 'Enter') void navigate(`/monitor/${task.campaignId}`) }}>
                <TableCell>
                  <div className={styles.productCell}>
                    <img className={styles.thumb} src={`/${task.image}`} alt={task.product} />
                    <div>
                      <p className={styles.productName}>{task.product}</p>
                      <p className={styles.adName}>{task.adName}</p>
                    </div>
                  </div>
                </TableCell>
                <TableCell><Badge tone={task.statusTone}>{task.status}</Badge></TableCell>
                <TableCell numeric>{task.spend}</TableCell>
                <TableCell numeric>{task.ctr}</TableCell>
                <TableCell className={styles.costCell}>
                  <small>{task.costLabel}</small>
                  <span className={`${styles.toneValue} ${styles[task.costTone]}`}>{task.costValue}</span>
                </TableCell>
                <TableCell numeric>{task.roas}</TableCell>
                <TableCell numeric className={`${styles.toneValue} ${styles[task.reachTone]}`}>{task.reach}</TableCell>
                <TableCell><span className={styles.monitor}><i className={`${styles.dot} ${styles[task.monitorTone]}`} />{task.monitorText}</span></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </Card>
  )
}
